import React, { useContext, useState } from "react";
import FileList from "../fileList/fileList";
import ClientTable from "../clientTable/clientTable";
import { Button, Modal } from "react-bootstrap";
import RejectionHistoryTable from "../rejectionHistoryTable/rejectionHistoryTable";
import SuccessModal from "../modals/successModal/successModal";
import RejectModal from "../modals/rejectModal/rejectModal";
import ReportsService from "../../../../../../../../../../services/reports-service";
import { IdentityContext } from "../../../../../../../../../../context/identity-context";

const ReportDetails = ({ report }) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const { user } = useContext(IdentityContext);
  const reportService = new ReportsService();
  const IssuerName = user.attributes['custom:display_name'];

  const handleSendReport = async () => {
    try {
      await reportService.issuerAcceptTaxExemptReport(
        report.reportHash,
        report.interestPaymentDate,
        IssuerName
      );
      setShowSuccessModal(true);
    } catch (error) {
      console.error("Error sending report:", error);
    }
  };

  const handleRejectReport = () => {
    setShowRejectModal(true);
  };

  const handleProceed = async () => {
    setIsProcessing(true);
    await handleSendReport();
    setIsProcessing(false);
    setShowConfirmModal(false);
  };

  const isDisabled = report.status !== "Reports Available";

  return (
    <>
      <FileList files={report.files} report={report} />
      <ClientTable clients={report.clients} />
      <RejectionHistoryTable rejectionHistory={report.rejectionHistory} />
      <div className="d-flex justify-content-end">
        <Button variant="danger" className="me-2" onClick={handleRejectReport} disabled={isDisabled}>
          Reject
        </Button>
        <Button
          variant="primary"
          className="mx-2"
          onClick={() => setShowConfirmModal(true)}
          disabled={isDisabled}
        >
          Accept Report
        </Button>
      </div>

      {/* Confirmation Modal */}
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Acceptance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        Accepting the Tax Exempt reports will prevent you from previewing and downloading its files. Do you want to proceed?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)} disabled={isProcessing}>
            Close
          </Button>
          <Button variant="primary" onClick={handleProceed} disabled={isProcessing}>
            {isProcessing ? "Processing..." : "Proceed"}
          </Button>
        </Modal.Footer>
      </Modal>

      <SuccessModal show={showSuccessModal} handleClose={() => setShowSuccessModal(false)} report={report} />
      <RejectModal show={showRejectModal} handleClose={() => setShowRejectModal(false)} report={report} />
    </>
  );
};

export default ReportDetails;
